/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DataImportRowChangeType = {
    _11184809: '11184809',
    ERROR: 'ERROR',
    NEW: 'NEW',
    UPDATE: 'UPDATE',
    NO_CHANGE: 'NO_CHANGE',
    DELETE: 'DELETE',
    unknown_default_open_api: '11184809'
} as const;
export type DataImportRowChangeType = typeof DataImportRowChangeType[keyof typeof DataImportRowChangeType];


export function instanceOfDataImportRowChangeType(value: any): boolean {
    for (const key in DataImportRowChangeType) {
        if (Object.prototype.hasOwnProperty.call(DataImportRowChangeType, key)) {
            if (DataImportRowChangeType[key as keyof typeof DataImportRowChangeType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DataImportRowChangeTypeFromJSON(json: any): DataImportRowChangeType {
    return DataImportRowChangeTypeFromJSONTyped(json, false);
}

export function DataImportRowChangeTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataImportRowChangeType {
    return json as DataImportRowChangeType;
}

export function DataImportRowChangeTypeToJSON(value?: DataImportRowChangeType | null): any {
    return value as any;
}

